import PrescriptionFillsMailOrderedContainer from './prescriptions-fills-mail-ordered-container';

export default PrescriptionFillsMailOrderedContainer;
